module.exports = __webpack_public_path__ + "img/lazy-src.a48d4f7e.jpg";